/**
 * Firestore collection names constants.
 * Using English names for consistency and maintainability.
 */

// Main collections
export const COLLECTIONS = {
  // Users and authentication
  USERS: 'users',
  CLIENT_USERS: 'clientUsers',

  // Products and inventory
  PRODUCTS: 'products',

  // Orders and sales
  ORDERS: 'orders',
  CLIENT_ORDERS: 'clientOrders',
  SALES: 'sales',

  // Organizations and business entities
  ORGANIZATIONS: 'organizations',
  CLIENTS: 'clients',
  SALES_PEOPLE: 'salesPeople',
} as const;

// Collection paths for subcollections
export const SUBCOLLECTIONS = {
  // User-specific collections
  USER_ORDERS: (userId: string) => `users/${userId}/orders`,
  USER_SALES: (userId: string) => `users/${userId}/sales`,

  // Organization-specific collections
  ORG_SALES_PEOPLE: (orgId: string) => `organizations/${orgId}/salesPeople`,
  ORG_CLIENTS: (orgId: string) => `organizations/${orgId}/clients`,
  ORG_CLIENT_USERS: (orgId: string) => `organizations/${orgId}/clientUsers`,
  ORG_PRODUCTS: (orgId: string) => `organizations/${orgId}/products`,
  /** Public product catalogs (shareable links). Path: organizations/{orgId}/publicCatalogs */
  ORG_PUBLIC_CATALOGS: (orgId: string) => `organizations/${orgId}/publicCatalogs`,
  ORG_SUPPLIERS: (orgId: string) => `organizations/${orgId}/suppliers`,
  ORG_SALES_ZONES: (orgId: string) => `organizations/${orgId}/salesZones`,
  ORG_PANEL_ROLES: (orgId: string) => `organizations/${orgId}/panelRoles`,
  ORG_PURCHASES: (orgId: string) => `organizations/${orgId}/purchases`,
} as const;

// Subcollection names (path segments)
export const SUBCOLLECTION_NAMES = {
  // SalesPeople -> Clients access mapping
  SALES_PERSON_CLIENTS: 'clients',
} as const;
